{
  "title": "需補填的報名資料與提醒信",
  "description": "查看已完成報名、但答案不符合目前表單的學生名單，並在預覽與測試信之後傳送補填提醒。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，需補填的學生會收到提醒信，補填並儲存後自動從名單消失。",
  "roleNote": "主辦方",
  "prerequisites": [
    "具備隊伍管理權限（名單所有人可看，寄信按鈕需要此權限）",
    "競賽設定已填寫「聯絡信箱」"
  ],
  "pathLabel": "競賽管理 → 資料 → 報名資料",
  "steps": [
    {
      "title": "1. 查看名單",
      "description": "「報名資料」頁最上方的「需補填的報名資料」列出已完成報名、但已儲存答案不符合目前已發布表單的學生：姓名、隊伍、尚需補填的欄位，不含 Email 與答案。沒有人需要補填時整個區塊不顯示。表單改版後新增必填欄位，或必填勾選框沒有勾選，都會使學生出現在這裡。"
    },
    {
      "title": "2. 寄測試信給自己",
      "description": "按「寄測試信給我自己」，只會寄到你本人的信箱並標示【測試】，用來確認信件內容與信末的主辦單位聯絡信箱。"
    },
    {
      "title": "3. 預覽並傳送提醒",
      "description": "按「傳送補填提醒」，對話框會先顯示收件人數與信件預覽（實際會寄出的主旨與內文）；按「取消」不會寄出，按確認才會寄給該學生本人，不會寄給隊友或教師。"
    }
  ],
  "afterward": [
    "學生補填並儲存後，會自動從名單消失",
    "寄送結果會在稽核紀錄留下摘要，含成功與失敗人數，不含 Email 位址",
    "本頁不會替學生填寫或修改任何報名資料，也不會改變學生的報名進度"
  ],
  "nextSteps": "若要通知的對象不限於需補填的學生，請見「如何發布公告並寄 Email 通知」。",
  "faq": [
    {
      "q": "看不到「需補填的報名資料」區塊？",
      "a": "沒有人需要補填時整個區塊不會顯示；另外「寄測試信給我自己」與「傳送補填提醒」只有具備隊伍管理權限的人看得到。"
    },
    {
      "q": "可以重複寄提醒嗎？",
      "a": "可以，但每次都會寄給仍在名單上的學生，寄之前請看人數與預覽。"
    },
    {
      "q": "學生在畫面上會看到什麼？",
      "a": "競賽頁的報名資料卡片、「我的競賽」卡片與首頁都會顯示「需補填」，補填後消失。"
    }
  ]
}
